@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/functions/global.functions' as globalFunctions;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/typography.variables';

$ontario-page-navigation-border-width: spacing.$spacing-1;
$ontario-page-navigation-content-max-width: 46rem;
$ontario-page-navigation-list-indent: spacing.$spacing-4 + spacing.$spacing-1;

:host {
	display: block;
}

.ontario-page-navigation {
	border-top: $ontario-page-navigation-border-width solid colours.$ontario-colour-black;
	border-bottom: $ontario-page-navigation-border-width solid colours.$ontario-greyscale-20;
	padding: spacing.$spacing-0;
	margin: spacing.$spacing-7 spacing.$spacing-0;
}

.ontario-page-navigation-content {
	padding: spacing.$spacing-7 spacing.$spacing-0;
	max-width: $ontario-page-navigation-content-max-width;
}

.ontario-page-navigation--no-top-border {
	border-top: none;

	.ontario-page-navigation-content {
		padding-top: spacing.$spacing-0;
	}
}

.ontario-page-navigation-header {
	@extend %h3-styles;
	margin-bottom: spacing.$spacing-0;
}

.ontario-page-navigation__skip-link {
	position: absolute;
	left: globalFunctions.px-to-rem(-9999);
	top: auto;
	width: globalFunctions.px-to-rem(1);
	height: globalFunctions.px-to-rem(1);
	overflow: hidden;

	&:focus,
	&:focus-visible {
		position: static;
		width: auto;
		height: auto;
		overflow: visible;
		margin-top: spacing.$spacing-2;
		padding: spacing.$spacing-1 spacing.$spacing-2;
		background-color: colours.$ontario-colour-white;
	}
}

.ontario-page-navigation-list {
	padding: spacing.$spacing-0;
	padding-left: $ontario-page-navigation-list-indent;
	margin: spacing.$spacing-0;
	margin-top: spacing.$spacing-4;
	list-style-type: disc;
}
